export enum OrderItemFulfillmentStatusEnum {
  Pending = 1,
  Partial = 2,
  Cancelled = 3,
  Concluded = 4
}
